import { render, staticRenderFns } from "./levelIcon.vue?vue&type=template&id=60fa1169&"
import script from "./levelIcon.vue?vue&type=script&lang=js&"
export * from "./levelIcon.vue?vue&type=script&lang=js&"
import style0 from "./levelIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "levelIcon.vue"
export default component.exports